import { FieldArrayRenderProps } from "formik";
import { BulkTicketTransferProps } from "../../types";
import { MaterialTableColumn } from "shared/components/materialTable/types";
import { ApiBulkTicket } from "apps/myExperience/modules/bulkTicketManagement/types";
import React from "react";
import { getBulkTicketsInfo } from "apps/myExperience/modules/bulkTicketManagement/utils";
import sortBy from "lodash/sortBy";
import MaterialTable from "shared/components/materialTable";
import { useColumnsForBulkTicketsTransferViewMode } from "../utils";

export function BulkTicketViewMode(
  props: BulkTicketTransferProps & {
    helpers?: FieldArrayRenderProps;
    values?: Array<string>;
    column?: MaterialTableColumn<ApiBulkTicket>;
  }
) {
  const columns: Array<MaterialTableColumn<ApiBulkTicket>> = useColumnsForBulkTicketsTransferViewMode();
  const info = React.useMemo(() => getBulkTicketsInfo(props.bulkTickets), [props.bulkTickets]);
  return (
    <React.Fragment>
      {sortBy(Object.keys(info.purchasesByFormType)).map(formType => {
        const purchases = sortBy(
          info.purchasesByFormType[formType].filter(item => item.valid),
          "purchasedOn"
        );
        if (!purchases.length) {
          return null;
        }
        return (
          <div className="blkTicketTransferModal_listing" key={formType}>
            <div className="blkTicketTransferModal_tableWrapper">
              <span className="blkTicketTransferModal_tableHeader">{formType}</span>
              <MaterialTable columns={columns} data={purchases} />
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
}
